import styled from 'styled-components';
import { getBackgroundColor, themeGet, getTextColor } from '@magalu/stereo-ui-styles';
import { SidebarHeader as SidebarHeaderComp } from '../../organisms/Sidebar';
import { Box, Heading, Flex, Text, Image } from '../../atoms';
export const SidebarHeader = styled(SidebarHeaderComp)`
  background-color: ${props => getBackgroundColor('primary')(props)};
  color: ${props => getTextColor('lightest')(props)};
`;
export const Wrapper = styled(Box)`
  padding: 0 12px;
  max-width: 1366px;
  margin: auto;
`;
export const ProductMiniatureContent = styled(Flex)`
  align-items: center;
  margin: 10px 0;
`;
export const ProductImage = styled(Image)`
  width: 60px;
  height: 60px;
`;
export const ProtectProduct = styled(Heading)`
  color: ${props => getTextColor('scratched')(props)};
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
  line-height: ${props => themeGet('lineHeights.input')(props)}em;
  margin-left: 5px;
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
`;
export const TitleContent = styled(Flex)`
  align-items: center;
  color: ${props => getTextColor('base')(props)};
`;
export const Description = styled(Heading)`
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
  margin-left: 5px;
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
`;
export const Separator = styled.div`
  padding-bottom: 10px;
  margin-bottom: 5px;
`;
export const TermItem = styled(Flex)`
  padding: 16px 14px;
  justify-content: space-between;
  cursor: pointer;
  p {
    color: ${props => getTextColor('base')(props)};
    font-size: ${props => themeGet('fontSizes.2')(props)}px;
  }
`;
export const RegulationText = styled(Text)``;
export const ConciseText = styled(Text)`
  text-align: center;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
`;